<template>
  <component
    :is="shouldShowLink ? 'iLink' : 'iText'"
    :href="shouldShowLink ? (href || computedHref) : undefined"
    v-bind="fullTextOptionsAttributes"
    :style-overrides="myStyleOverrides"
    :border-top="myBorderSides.top"
    :border-bottom="myBorderSides.bottom"
    :border-left="myBorderSides.left"
    :border-right="myBorderSides.right"
    :target="shouldShowLink ? target : undefined"
    :rel="shouldShowLink ? rel : undefined"
    :width="fullTextOptionsAttributes.width"
    :min-width="fullTextOptionsAttributes.minWith"
    :max-width="fullTextOptionsAttributes.maxWith"
    :background-position="shouldShowLink ? getOptionValue(BackgroundPosition) : undefined"
    :background-size="shouldShowLink ? getOptionValue(BackgroundSize) : undefined"
    :background-repeat="shouldShowLink ? getOptionValue(BackgroundRepeat) : undefined"
    :hover-background-position="shouldShowLink ? getOptionValue(BackgroundPosition, BaseOption.$states.HOVER) : undefined"
    :hover-background-size="shouldShowLink ? getOptionValue(BackgroundSize, BaseOption.$states.HOVER) : undefined"
    :hover-background-repeat="shouldShowLink ? getOptionValue(BackgroundRepeat, BaseOption.$states.HOVER) : undefined"
  >
    <slot>
      <iRichText
        v-if="(!hasLabel && editMode) || (hasTextContent && !editMode && !hasLabel)"
        ref="richTextElement"
        :model-value="initialValue"
        prevent-new-line
        :placeholder="editMode ? 'Enter text here' : ''"
        :preview="previewMode"
        :show-toolbar="false"
        :show-bubble-menu="true"
        :tools-to-disable="['text-align', 'link', 'bullet-list']"
        :style-overrides="{
          borderWidth: 'none',
          borderRadius: 'none',
          paddingLeft: 'none',
          paddingRight: 'none',
          paddingTop: 'none',
          paddingBottom: 'none',
        }"
        v-bind="textOnlyAttributes"
        @click="editMode && handleClick($event)"
        @blur="handleBlur"
        @keydown.enter="handleBlur"
        @update:model-value="handleTextOptionUpdate($event)"
      />
      <template v-else-if="hasLabel">
        <PrefixSuffixWrapper
          v-if="getOptionValue(Prefix) || getOptionValue(Suffix)"
          :prefix="getOptionValue(Prefix)"
          :suffix="getOptionValue(Suffix)"
          :style-bindings="textOnlyAttributes"
        >
          {{ label }}
        </PrefixSuffixWrapper>
        <template v-else>
          {{ label }}
        </template>
      </template>
    </slot>
  </component>
</template>

<script>
import {
  UrlElementMixin,
} from "%/dynamic-components/render-engine/components/production/elements/url-element/url-element-mixin";
import AppearanceOptions from "%/dynamic-components/render-engine/bundles/appearance-options";
import BrandedTextStyleOptions from "%/dynamic-components/render-engine/bundles/branded-text-style-options";
import BasicTextOptions from "%/dynamic-components/render-engine/bundles/basic-text-options";
import TextOptions from "%/dynamic-components/render-engine/bundles/text-options";
import SpacingOptions from "%/dynamic-components/render-engine/bundles/spacing-options";
import LayoutWidthHeightOptions from "%/dynamic-components/render-engine/bundles/layout-width-height-options";
import BorderOptions from "%/dynamic-components/render-engine/bundles/border-options";
import BackgroundOptions from "%/dynamic-components/render-engine/bundles/background-options";
import PrefixSuffixWrapper from "%/components/PrefixSuffixWrapper.vue";
import Suffix from "%/dynamic-components/render-engine/options/action-options/suffix";
import Prefix from "%/dynamic-components/render-engine/options/action-options/prefix";
import HrefAction from "%/dynamic-components/render-engine/options/click-actions/href-action";
import BackgroundImage from "%/dynamic-components/render-engine/options/background-options/background-image";
import BackgroundGradient from "%/dynamic-components/render-engine/options/background-options/background-gradient";
import AnimationEffectsOptions from "%/dynamic-components/render-engine/bundles/animation-effects-options";

export default {
  name: "UrlElement",
  components: { PrefixSuffixWrapper },
  elementPanelSettings: {
    displayName: "Link",
    displayIcon: "hyperlink",
    elementGroup: "general",
  },
  mixins: [UrlElementMixin],
  data() {
    return {
      Suffix,
      Prefix,
      BackgroundGradient,
      BackgroundImage,
    };
  },
  optionBundles: [
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
    new BrandedTextStyleOptions({
      "default.text-branding-style-option": "paragraph",
    }, {
      "text-option": true,
    }),
    BasicTextOptions,
    TextOptions,
    SpacingOptions,
    new LayoutWidthHeightOptions({
      "default.layout-width": "hug",
      "default.layout-height": "hug",
    }, {
      "layout-height": true,
      "max-height": true,
      "min-height": true,
    }),
    BorderOptions,
    new BackgroundOptions({}, {
      "background-image": true,
    }),
    AnimationEffectsOptions,
  ],
  options: [
    HrefAction,
  ],
};
</script>

<style scoped lang="scss">
</style>
